import { createAsyncThunk } from '@reduxjs/toolkit';
import wistiaApi from 'students/api/wistia';
import { actions } from './slice';

export interface IOnboardingVideoModalContext {
  iframe?: string | null;
  programName?: string | null;
  userName?: string | null;
  skipLink?: string | null;
  url?: string | null;
}

/**
 * Plans often store a Wistia share link (`<account>.wistia.com/s/<id>`), which the
 * player cannot load; resolve it to an embed url before the modal mounts.
 */
const openOnboardingVideoModal = createAsyncThunk<void, IOnboardingVideoModalContext>(
  'modal/openOnboardingVideoModal',
  async (context, { dispatch }) => {
    const url = context.url ? await wistiaApi.resolvePlayableVideoUrl(context.url) : null;

    dispatch(actions.open('OnboardingVideoModal', { ...context, url }));
  }
);

export const modalThunks = { openOnboardingVideoModal };
